import { FC, useContext, useRef } from "react";
import { ReportCustomizationContext } from "../ReportCustomizationContext";
import { handleToastError, handleToastSuccess, reportTypeToColumnsEndpointMap } from "../helpers/helpers";
import { NetworkProviderComparisonType } from "@app/exports/enumerations";
import ExportService from "@app/exports/exportService";
import { ClosestProviderReportModel } from "@app/exports/exportModels";
import { GenerateSection } from "../components/GenerateSection";
import { ColumnConfigurationSection } from "../components/ColumnConfigurationSection";
import { ReportCustomizationReducerActions } from "../interfaces/reportCustomizationReducerActionsEnum";
import { ReportType } from "../interfaces/reportTypeEnum";

export const ClosestProviderReport: FC = () => {
  const rcContext = useContext(ReportCustomizationContext);
  const exportService = useRef(new ExportService()).current;

  const getExportModel = () => {
    const newComparisonTypes = [];
    if (rcContext.state.showAddedProviders)
      newComparisonTypes.push(NetworkProviderComparisonType.Added);
    if (rcContext.state.showMatchedProviders)
      newComparisonTypes.push(NetworkProviderComparisonType.Matched);
    if (rcContext.state.showRemovedProviders)
      newComparisonTypes.push(NetworkProviderComparisonType.Removed);

    const closestProviderModel: ClosestProviderReportModel = {
      customProjectId: parseInt(rcContext.routeParams.projectId),
      eMailOnSuccess: rcContext.state.shouldEmailLink,
      exportName: rcContext.state.filename,
      formatType: rcContext.state.fileFormat,
      networkAssessmentAnalysisType: rcContext.routeState.networkAssessmentAnalysisType,
      projectRunConfigurationId: parseInt(rcContext.state.timeslice),
      projectUrl: `${window.customUIAbsolutePath}/projects/${rcContext.routeParams.projectId}`,
      regionSetIds: [],
      reportCustomizationId: rcContext.state.selectedPreset?.id,
      runAsynchronous: true,
      runFrequency: rcContext.state.runFrequency,
      sharedUsers: rcContext.state.sharedUsers,
    };

    return closestProviderModel;
  };

  // event handlers
  const handleGenerateClick = () => {
    rcContext.dispatch({ payload: { isGenerating: true }, type: ReportCustomizationReducerActions.ChangeIsGenerating });

    exportService.postExportClosestProvider(getExportModel())
      .then(() => handleToastSuccess(rcContext.state.filename),
        () => handleToastError(rcContext.state.filename)
      ).then(() => {
        rcContext.dispatch({ payload: { isGenerating: false }, type: ReportCustomizationReducerActions.ChangeIsGenerating });
      });
  }

  const isValid = rcContext.state.selectedMemberships.length === 1
    && !!rcContext.state.timeslice && !rcContext.state.isCompareMode
    && !!rcContext.state.filename;

  return (
    <>
      <div className="container ms-0">
        <ColumnConfigurationSection
          columnsEndpoint={reportTypeToColumnsEndpointMap.get(ReportType.ClosestProvidersToMembers)}
          exportModel={getExportModel()}
          presets={rcContext.state.presets}
          selectedPreset={rcContext.state.selectedPreset}
          reportType={rcContext.getReportType()}
          onPresetChange={rcContext.changeSelectedPreset}
          onPresetsRefresh={rcContext.changeLoadedPresets}
        />
      </div>
      <GenerateSection
        settingsAreValid={isValid}
        onGenerate={handleGenerateClick}
      />
    </>
  );
}